<footer class="footer stick-down" [matMenuTriggerFor]="profileMenu" id="sign-out-dropdown">



  <div class="profile-block">
    <img class="avatar" [src]="avatarUrl" alt="avatar"/>
    <div class="info">
      <div class="name">{{ fullName }}</div>
      <div class="email">{{ userName }}</div>
    </div>
    <mat-icon class="expand-icon">expand_more</mat-icon>
  </div>

  <mat-menu #profileMenu="matMenu" class="profile-menu-panel">
    <div class="menu-header">
      <img class="avatar-lg" [src]="avatarUrl"/>
      <div>
        <div class="name">{{ fullName }}</div>
        <div class="email">{{ userName }}</div>
      </div>
    </div>
    <ng-container *ngFor="let menu of allAppMenus$ | async">
      <ng-container *ngIf="checkGuards(menu.guards) | async">
        <a mat-menu-item
           routerLink="{{ menu.link }}"
           [id]="menu.e2EId"
        >
          {{ menu.name }}
        </a>
      </ng-container>
    </ng-container>
    <div class="legal-links">
      <a href="https://www.microting.com/terms-of-service" target="_blank">Terms</a>
      <span>|</span>
      <a href="https://www.microting.com/privacy-policy" target="_blank">Privacy</a>
      <span>|</span>
      <a href="https://www.microting.com/data-protection-terms-gdpr" target="_blank">GDPR</a>
    </div>

  </mat-menu>
</footer>
